export function isSelectingMarker(scope, image, event) {
  const hitResult = scope.project.hitTest(event.point);
  if (!hitResult) {
    return false;
  }

  // Raster hits are reported as 'pixel': the background diagram image is
  // not a marker, but position-image markers (also rasters) are.
  if (hitResult.type === 'pixel') {
    return hitResult.item !== image;
  }

  return true;
}

export function delegateToSelectTool(vm, event) {
  vm.handleOnMouseDownMarkerSelection(event);
  vm.switchBackTool = vm.scope.tool;
  vm.selectTool.activate();
}

export function handleCreationToolMouseDown(vm, event, createFn) {
  if (vm.readOnly || vm.isTaskCompleted) {
    if (vm.isTaskCompleted) vm.taskCompletedError();
    return false;
  }

  if (isSelectingMarker(vm.scope, vm.image, event)) {
    delegateToSelectTool(vm, event);
    return false;
  }

  if (vm.processingNewBubble) {
    vm.showProcessingBubblePopup();
    return false;
  }

  vm.toolPanStartPoint = event.point;
  vm.isMovingImage = false;
  vm.pendingToolAction = () => createFn(event);
  return true;
}

export function handleCreationToolMouseDrag(vm, event) {
  if (!vm.toolPanStartPoint || !vm.pendingToolAction) {
    return;
  }

  const dragDistance = Math.hypot(
    event.point.x - vm.toolPanStartPoint.x,
    event.point.y - vm.toolPanStartPoint.y
  );

  if (dragDistance > 1) {
    vm.isMovingImage = true;
  }

  if (vm.isMovingImage) {
    vm.moveImageTo(event.lastPoint, event.point);
  }
}

export async function handleCreationToolMouseUp(vm) {
  const wasPanning = vm.isMovingImage;
  const action = vm.pendingToolAction;
  vm.toolPanStartPoint = null;
  vm.pendingToolAction = null;
  vm.isMovingImage = false;

  if (!wasPanning && action) {
    await action();
  }
}

export function attachCreationToolPanHandlers(vm, tool) {
  tool.onMouseDrag = (event) => {
    handleCreationToolMouseDrag(vm, event);
  };
  tool.onMouseUp = async () => {
    await handleCreationToolMouseUp(vm);
  };
}
